import './orbit-foundation.min.css';
import '../font-faces/Digital7.css';


import {css} from "styled-components";

export function makeCommonGlobalStyles() {
    return css`
        html {
            font-size: 10px;
        }

        html.cgp-pc.cgp-pc-low-resolution, html.cgp-pc.cgp-low-height {
            font-size: 8px;
        }

        html, body {
            scroll-behavior: smooth;
        }

        body {
            color: ${({theme}) => theme.colors.textLight};
            background-color: ${({theme}) => theme.colors.background};
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

        body > #page {
            display: none
        }

        body.no-scrolling {
            overflow: hidden;
        }

        body.cgp-overlay-open {
            overflow: hidden;
        }

        #orbit-container {
            width: 100%;
        }

        html:not(.cgp-mobile) #orbit-container {
            display: flex;
        }

        section:after, section:before, header:after, header:before, footer:before, footer:after, main:before, main:after {
            display: table;
            content: " ";
        }

        section:after, header:after, footer:before, main:after {
            clear: both;
        }

        a, a:focus, a:hover, a:active {
            outline: none;
            outline: 0;
            -webkit-box-shadow: none;
            box-shadow: none;
            -webkit-tap-highlight-color: transparent;
        }

        a, a:focus, a:hover, a:active {
            color: inherit;
        }
 
        .cgp-pc {
            // the standardized scrollbar-width and scrollbar-color properties (for Firefox for now).
            // works for all elements except body
            * {
                scrollbar-width: thin;
                /* Foreground, Background */
                scrollbar-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.1);
            }

            // Chrome and Safari
            *::-webkit-scrollbar {
                width: 7px;
            }

            *::-webkit-scrollbar-track {
                background: rgba(255, 255, 255, 0.1);
            }

            *::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.5);
            }

            *::-webkit-scrollbar-thumb:hover {
                background: rgba(255, 255, 255, 0.8);
            }
        }

    `
}